import { Size } from "@repo/ui/helpers/helpers";
import { entityTable } from "@repo/ui/tables/entityTable";
import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SettingsTableBodySectionProps {
  children: ReactNode;
}

export const SettingsTableBodySection: FC<SettingsTableBodySectionProps> = (
  props,
) => (
  <tbody
    className={twMerge(
      entityTable({ size: Size.SMALL }).body(),
      "[&>tr:last-child>td:first-child]:rounded-bl-md [&>tr:last-child>td:last-child]:rounded-br-md",
    )}
  >
    {props.children}
  </tbody>
);
